import { LuSearch } from "@/Components/Icons/Icons";
export default {
  row1 : [
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "importProductBatchId",
          label: "Batch ID",
          component: "text-field",
        },
        {
          name: "importProductBatchQuantity",
          label: "Batch Quantity",
          component: "text-field",
          dataType : "int"
        },
      ],
     row2: [
        {
          name: "importProductBatchunit",
          label: "Batch Unit",
          component: "text-field",
          icon: LuSearch,
          iconColor: "gray-400",
          type: "autocomplete",
          endpoint : "getQuantity",
           width:"50%"
        },
        {
          name: "importProductManufacuturerDate",
          label: "Manufacture Date",
          component: "dateselector",
          width:"50%"
        },
      ],
      row3: [
        {
          name: "importProductExpiryDate",
          label: "Expiry Date",
          component: "dateselector",
          width:"50%"
          
        },
        {
          name: "importProductBestBeforeDate",
          label: "Best Before Date",
          component: "dateselector",
          width:"50%",
          disabled : true,

        },
      ],
      
    },
  },
]
};
